import { Card, Button } from "antd";
import { AppURL } from "utils/Actions";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "redux/hooks";

import styles from "./style.module.css";
import check from "assets/icons/checkbox-circle-line.svg";
import pause from "assets/icons/information-line.svg";
import loading3Quarters from "assets/icons/loader-3-line.svg";
import Restricted from "../restricted";
import { PERMISSIONS } from "permissions/app-permissions";

export default function SRSStatisticsCard() {
  const history = useHistory();
  const { t } = useTranslation();

  const { statistics } = useAppSelector(state => state.srsApplicants);
  const {
    totalApplicants: totalSRS,
    ratedApplicants,
    unratedApplicants,
    partiallyRatedApplicants
  } = statistics;
  const { isSrsOpen } = useAppSelector(state => state.properties.closingData);

  const goToSRSApplicationPage = () => {
    history.push(`${AppURL.school.rater.srsApplications}`);
  };

  return (
    <Card
      title={
        <div className={styles["srs-table-header"]}>
          <h2 className="card-title">{t("dashboard.card-3")}</h2>
        </div>
      }
      className={styles.card}
    >
      <div className="hide-desktop">
        <table className={styles["srs-table"]}>
          <caption className="sr-only">Status of SRS applications</caption>
          <tbody>
            <tr className={styles.tr}>
              <th className={styles.th}>{t("dashboard.card-3-total")}</th>
            </tr>
            <tr className={styles["statistic-lg"]}>
              <td className={styles.totalTd}>{totalSRS}</td>
            </tr>
            <tr>
              <th className={styles.th}>
                <img src={check} style={{ marginRight: 8 }} alt="" />
                {t("dashboard.card-3-complete")}
              </th>
              <td className={styles["mobile-statistic"]}>{ratedApplicants}</td>
            </tr>
            <tr>
              <th className={styles.th}>
                <img src={loading3Quarters} style={{ marginRight: 8 }} alt="" />
                {t("dashboard.card-3-partial")}
              </th>
              <td className={styles["mobile-statistic"]}>{partiallyRatedApplicants}</td>
            </tr>
            <tr>
              <th className={styles.th}>
                <img src={pause} style={{ marginRight: 8 }} alt="" />
                {t("dashboard.card-3-unrated")}
              </th>
              <td className={styles["mobile-statistic"]}>{unratedApplicants}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="show-desktop">
        <table className={styles["srs-table"]}>
          <caption className="sr-only">Status of SRS applications</caption>
          <thead>
            <tr className={styles.tr}>
              <th className={styles.th}>{t("dashboard.card-3-total")}</th>
              <th className={styles.th}>
                <img src={check} style={{ marginRight: 8 }} alt="" />
                {t("dashboard.card-3-complete")}
              </th>
              <th className={styles.th}>
                <img src={loading3Quarters} style={{ marginRight: 8 }} alt="" />
                {t("dashboard.card-3-partial")}
              </th>
              <th className={styles.th}>
                <img src={pause} style={{ marginRight: 8 }} alt="" />
                {t("dashboard.card-3-unrated")}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr className={styles.tr}>
              <td className={styles["statistic-lg"]}>{totalSRS}</td>
              <td className={styles["statistic"]}>{ratedApplicants}</td>
              <td className={styles["statistic"]}>{partiallyRatedApplicants}</td>
              <td className={styles["statistic"]}>{unratedApplicants}</td>
            </tr>
          </tbody>
        </table>
      </div>
      {isSrsOpen && (
        <Restricted to={PERMISSIONS.DASHBOARD.VIEW_SRS_APPLICATIONS_LINK}>
          <Button
            type="link"
            aria-label="View applications for all SRS applicants"
            onClick={goToSRSApplicationPage}
            style={{ padding: 0 }}
          >
            View applications
          </Button>
        </Restricted>
      )}
    </Card>
  );
}
